import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateViewDocument } from './create.generated';

export const useCreateView = (options: ApiOptions<typeof CreateViewDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(CreateViewDocument, {
    ...useNotifications(CreateViewDocument, {
      failure: t('api.common.error_generic'),
      success: (data) =>
        data.createView?.view?.name != null
          ? t('api.views.create_success', { name: data.createView.view.name })
          : t('api.views.create_success_no_name'),
    }),

    ...options,
  });
};
